import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CustomerPrivacyCategory } from './mask-data';
import { transform } from './transformer';

const LOCAL_STORAGE_PATH = 'chargeye-customer-privacy';

let initialValue = false;
try {
    initialValue = JSON.parse(localStorage.getItem(LOCAL_STORAGE_PATH) || 'false');
} catch (e) {
    console.error(e);
}
const enabled$ = new BehaviorSubject<boolean>(initialValue);
enabled$.subscribe((enabled) => {
    localStorage.setItem(LOCAL_STORAGE_PATH, JSON.stringify(enabled));
});

@Injectable({
    providedIn: 'root',
})
export class CustomerPrivacyService {
    private _enabled$ = enabled$.asObservable();
    get enabled() {
        return enabled$.value;
    }
    get enabled$() {
        return this._enabled$;
    }

    toggle() {
        enabled$.next(!enabled$.value);
    }

    transform(original: string[], category: CustomerPrivacyCategory): string[];
    transform(original: string, category: CustomerPrivacyCategory): string;
    transform(original: string | string[], category: CustomerPrivacyCategory): string | string[] {
        if (this.enabled) {
            return transform(original as any, category);
        } else {
            return original;
        }
    }
}
